
// NDJSON over web streams (works on Node 22 and in the browser alike) — the task-log
// transport, with ?follow streaming until the task finishes.

export async function* ndjsonLines(body: ReadableStream<Uint8Array>): AsyncGenerator<Record<string, unknown>> {
    const reader = body.getReader();
    const decoder = new TextDecoder();
    let buffer = "";
    try {
        for (;;) {
            const { done, value } = await reader.read();
            if (done) {
                break;
            }
            buffer += decoder.decode(value, { stream: true });
            for (let nl = buffer.indexOf("\n"); nl !== -1; nl = buffer.indexOf("\n")) {
                const line = buffer.slice(0, nl).trim();
                buffer = buffer.slice(nl + 1);
                if (line !== "") {
                    yield JSON.parse(line) as Record<string, unknown>;
                }
            }
        }
        if (buffer.trim() !== "") {
            yield JSON.parse(buffer) as Record<string, unknown>;
        }
    }
    finally {
        reader.releaseLock();
    }
}
